module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-president-suite-cover.2eb5de83.jpg";